import React, {Component} from 'react';
import './App.css';
import Web3 from 'web3';
import axios from 'axios';
import BigNumber from 'bignumber.js';
import Menu from './components/menu/index';
import BuySell from './components/buy-sell/index';
import Reinvest from './components/reinvest/index';
import Staking from './components/staking/index';
import MasterNode from './components/masternode/index';
import Transfer from './components/transfer/index';
import Footer from './components/footer/index';
import Loading from './components/loading/index';

const queryString = require('query-string');
const moment = require('moment');


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: true,
            fiatPrices: {},
            fiatTotal: 0.00,
            fiatGauntlet: 0,
            fiatBalance: 0,
            fiatDivs: 0,
            gauntletType: '',
            gauntletEndText: '',
            gauntletEndDateOrSupply: '',
            gauntletMustStakeUntil: '',
            gauntletMinimumSupply: '',
            reason: '',
            MN: '0xf96fA62314EB46DD9E6B92D25045732D7e1CB96C',
            masterNodeLink: '',
            stakingRequirementStr: '',
            ethNetworkID: 0,
            ethNetwork: '',
            etherscanAddr: '',
            currency: 'USD',
            P3XAbi: [{
                "constant": true,
                "inputs": [{"name": "customerAddress", "type": "address"}],
                "name": "dividendsOf",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "amount", "type": "uint256"}, {"name": "withdrawAfter", "type": "bool"}],
                "name": "sell",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {"constant": true, "inputs": [], "name": "name", "outputs": [{"name": "", "type": "string"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                "constant": false,
                "inputs": [{"name": "spender", "type": "address"}, {"name": "value", "type": "uint256"}],
                "name": "approve",
                "outputs": [{"name": "", "type": "bool"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "accountHolder", "type": "address"}],
                "name": "gauntletTypeOf",
                "outputs": [{"name": "stakeAmount", "type": "uint256"}, {"name": "gType", "type": "uint256"}, {"name": "end", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "ethereumToSpend", "type": "uint256"}],
                "name": "calculateTokensReceived",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "totalSupply",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "ethToReinvest", "type": "uint256"}],
                "name": "reinvestPartial",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "tokensToSell", "type": "uint256"}],
                "name": "calculateEthereumReceived",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "from", "type": "address"}, {"name": "to", "type": "address"}, {"name": "value", "type": "uint256"}],
                "name": "transferFrom",
                "outputs": [{"name": "success", "type": "bool"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "to", "type": "address"}, {"name": "ignore", "type": "bool"}],
                "name": "ignoreTokenFallback",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {"constant": true, "inputs": [], "name": "decimals", "outputs": [{"name": "", "type": "uint8"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                "constant": true,
                "inputs": [],
                "name": "myDividends",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "amount", "type": "uint256"}, {"name": "extGauntlet", "type": "address"}],
                "name": "acquireExternalGauntlet",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {"constant": false, "inputs": [], "name": "withdraw", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {
                "constant": true,
                "inputs": [],
                "name": "myGauntletType",
                "outputs": [{"name": "stakeAmount", "type": "uint256"}, {"name": "gType", "type": "uint256"}, {"name": "end", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "referrerName", "type": "string"}],
                "name": "buy",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": true,
                "stateMutability": "payable",
                "type": "function"
            }, {"constant": false, "inputs": [], "name": "allowIgnoreTokenFallback", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {
                "constant": true,
                "inputs": [],
                "name": "stakingRequirement",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "includeReferralBonus", "type": "bool"}],
                "name": "myDividends",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "r", "type": "uint256"}],
                "name": "setReferralRequirement",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "lastTotalBalance",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "accountHolder", "type": "address"}],
                "name": "balanceOf",
                "outputs": [{"name": "balance", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "customerAddress", "type": "address"}, {"name": "includeReferralBonus", "type": "bool"}],
                "name": "dividendsOf",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "customerAddress", "type": "address"}],
                "name": "refBonusOf",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "refHandlerAddress",
                "outputs": [{"name": "", "type": "address"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {"constant": true, "inputs": [], "name": "symbol", "outputs": [{"name": "", "type": "string"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                "constant": false,
                "inputs": [{"name": "amount", "type": "uint256"}, {"name": "gType", "type": "uint8"}, {"name": "end", "type": "uint256"}],
                "name": "acquireGauntlet",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {"constant": false, "inputs": [], "name": "donateDividends", "outputs": [], "payable": true, "stateMutability": "payable", "type": "function"}, {
                "constant": false,
                "inputs": [{"name": "ref", "type": "address"}],
                "name": "setReferrer",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "n", "type": "string"}, {"name": "s", "type": "string"}],
                "name": "rebrand",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "to", "type": "address"}, {"name": "value", "type": "uint256"}],
                "name": "transfer",
                "outputs": [{"name": "", "type": "bool"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "totalBalance",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "shitCoin", "type": "address"}],
                "name": "takeShitcoin",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "myRefBonus",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "ethToReinvest", "type": "uint256"}, {"name": "withdrawAfter", "type": "bool"}],
                "name": "reinvestPartial",
                "outputs": [{"name": "tokensCreated", "type": "uint256"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "refName", "type": "string"}],
                "name": "setReferrer",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "to", "type": "address"}, {"name": "value", "type": "uint256"}, {"name": "data", "type": "bytes"}],
                "name": "transfer",
                "outputs": [{"name": "", "type": "bool"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "from", "type": "address"}, {"name": "value", "type": "uint256"}, {"name": "data", "type": "bytes"}],
                "name": "tokenFallback",
                "outputs": [],
                "payable": false,
                "stateMutability": "pure",
                "type": "function"
            }, {"constant": true, "inputs": [], "name": "myBalance", "outputs": [{"name": "", "type": "uint256"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                "constant": true,
                "inputs": [{"name": "", "type": "address"}],
                "name": "savedReferral",
                "outputs": [{"name": "", "type": "address"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "sugardaddy", "type": "address"}, {"name": "spender", "type": "address"}],
                "name": "allowance",
                "outputs": [{"name": "remaining", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "amount", "type": "uint256"}],
                "name": "sell",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {"constant": false, "inputs": [], "name": "exit", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {
                "constant": true,
                "inputs": [{"name": "accountHolder", "type": "address"}],
                "name": "usableBalanceOf",
                "outputs": [{"name": "balance", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "refName", "type": "string"}],
                "name": "getAddressFromReferralName",
                "outputs": [{"name": "", "type": "address"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {"constant": false, "inputs": [], "name": "acceptNewOwner", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {
                "constant": false,
                "inputs": [{"name": "referrerAddress", "type": "address"}],
                "name": "buy",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": true,
                "stateMutability": "payable",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "baseHourglass",
                "outputs": [{"name": "", "type": "address"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "myUsableBalance",
                "outputs": [{"name": "balance", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "o", "type": "address"}],
                "name": "setNewOwner",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "to", "type": "address"}, {"name": "value", "type": "uint256"}, {"name": "data", "type": "bytes"}, {"name": "func", "type": "string"}],
                "name": "transfer",
                "outputs": [{"name": "", "type": "bool"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [],
                "name": "reinvest",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {"inputs": [{"name": "h", "type": "address"}, {"name": "p", "type": "address"}], "payable": false, "stateMutability": "nonpayable", "type": "constructor"}, {
                "payable": true,
                "stateMutability": "payable",
                "type": "fallback"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "tokenOwner", "type": "address"}, {"indexed": true, "name": "spender", "type": "address"}, {
                    "indexed": false,
                    "name": "tokens",
                    "type": "uint256"
                }],
                "name": "Approval",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "from", "type": "address"}, {"indexed": true, "name": "to", "type": "address"}, {"indexed": false, "name": "value", "type": "uint256"}],
                "name": "Transfer",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "from", "type": "address"}, {"indexed": true, "name": "to", "type": "address"}, {
                    "indexed": false,
                    "name": "value",
                    "type": "uint256"
                }, {"indexed": true, "name": "data", "type": "bytes"}],
                "name": "Transfer",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "accountHolder", "type": "address"}, {"indexed": false, "name": "ethereumSpent", "type": "uint256"}, {
                    "indexed": false,
                    "name": "tokensCreated",
                    "type": "uint256"
                }, {"indexed": false, "name": "tokensGiven", "type": "uint256"}, {"indexed": true, "name": "referrer", "type": "address"}, {"indexed": true, "name": "bitFlags", "type": "uint8"}],
                "name": "onTokenPurchase",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "accountHolder", "type": "address"}, {"indexed": false, "name": "tokensDestroyed", "type": "uint256"}, {
                    "indexed": false,
                    "name": "ethereumEarned",
                    "type": "uint256"
                }],
                "name": "onTokenSell",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "accountHolder", "type": "address"}, {"indexed": false, "name": "earningsWithdrawn", "type": "uint256"}, {
                    "indexed": false,
                    "name": "refBonusWithdrawn",
                    "type": "uint256"
                }, {"indexed": true, "name": "reinvestment", "type": "bool"}],
                "name": "onWithdraw",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "donator", "type": "address"}, {"indexed": false, "name": "ethereumDonated", "type": "uint256"}],
                "name": "onDonatedDividends",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "strongHands", "type": "address"}, {"indexed": false, "name": "stakeAmount", "type": "uint256"}, {
                    "indexed": true,
                    "name": "gauntletType",
                    "type": "uint8"
                }, {"indexed": false, "name": "end", "type": "uint256"}],
                "name": "onGauntletAcquired",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "strongHands", "type": "address"}, {"indexed": false, "name": "stakeAmount", "type": "uint256"}, {
                    "indexed": true,
                    "name": "extGauntlet",
                    "type": "address"
                }],
                "name": "onExternalGauntletAcquired",
                "type": "event"
            }],
            P3DAbi: [{
                "constant": true,
                "inputs": [{"name": "_customerAddress", "type": "address"}],
                "name": "dividendsOf",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {"constant": true, "inputs": [], "name": "name", "outputs": [{"name": "", "type": "string"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                "constant": true,
                "inputs": [{"name": "_ethereumToSpend", "type": "uint256"}],
                "name": "calculateTokensReceived",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "totalSupply",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "_tokensToSell", "type": "uint256"}],
                "name": "calculateEthereumReceived",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "onlyAmbassadors",
                "outputs": [{"name": "", "type": "bool"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {"constant": true, "inputs": [], "name": "decimals", "outputs": [{"name": "", "type": "uint8"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                "constant": true,
                "inputs": [{"name": "", "type": "bytes32"}],
                "name": "administrators",
                "outputs": [{"name": "", "type": "bool"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {"constant": false, "inputs": [], "name": "withdraw", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {
                "constant": true,
                "inputs": [],
                "name": "sellPrice",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "stakingRequirement",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "_includeReferralBonus", "type": "bool"}],
                "name": "myDividends",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [],
                "name": "totalEthereumBalance",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": true,
                "inputs": [{"name": "_customerAddress", "type": "address"}],
                "name": "balanceOf",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "_amountOfTokens", "type": "uint256"}],
                "name": "setStakingRequirement",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {"constant": true, "inputs": [], "name": "buyPrice", "outputs": [{"name": "", "type": "uint256"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                "constant": false,
                "inputs": [{"name": "_identifier", "type": "bytes32"}, {"name": "_status", "type": "bool"}],
                "name": "setAdministrator",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {"constant": true, "inputs": [], "name": "myTokens", "outputs": [{"name": "", "type": "uint256"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                "constant": true,
                "inputs": [],
                "name": "symbol",
                "outputs": [{"name": "", "type": "string"}],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }, {"constant": false, "inputs": [], "name": "disableInitialStage", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {
                "constant": false,
                "inputs": [{"name": "_toAddress", "type": "address"}, {"name": "_amountOfTokens", "type": "uint256"}],
                "name": "transfer",
                "outputs": [{"name": "", "type": "bool"}],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "_symbol", "type": "string"}],
                "name": "setSymbol",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "_name", "type": "string"}],
                "name": "setName",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {
                "constant": false,
                "inputs": [{"name": "_amountOfTokens", "type": "uint256"}],
                "name": "sell",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            }, {"constant": false, "inputs": [], "name": "exit", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {
                "constant": false,
                "inputs": [{"name": "_referredBy", "type": "address"}],
                "name": "buy",
                "outputs": [{"name": "", "type": "uint256"}],
                "payable": true,
                "stateMutability": "payable",
                "type": "function"
            }, {"constant": false, "inputs": [], "name": "reinvest", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {
                "inputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "constructor"
            }, {"payable": true, "stateMutability": "payable", "type": "fallback"}, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "customerAddress", "type": "address"}, {"indexed": false, "name": "incomingEthereum", "type": "uint256"}, {
                    "indexed": false,
                    "name": "tokensMinted",
                    "type": "uint256"
                }, {"indexed": true, "name": "referredBy", "type": "address"}],
                "name": "onTokenPurchase",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "customerAddress", "type": "address"}, {"indexed": false, "name": "tokensBurned", "type": "uint256"}, {
                    "indexed": false,
                    "name": "ethereumEarned",
                    "type": "uint256"
                }],
                "name": "onTokenSell",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "customerAddress", "type": "address"}, {"indexed": false, "name": "ethereumReinvested", "type": "uint256"}, {
                    "indexed": false,
                    "name": "tokensMinted",
                    "type": "uint256"
                }],
                "name": "onReinvestment",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "customerAddress", "type": "address"}, {"indexed": false, "name": "ethereumWithdrawn", "type": "uint256"}],
                "name": "onWithdraw",
                "type": "event"
            }, {
                "anonymous": false,
                "inputs": [{"indexed": true, "name": "from", "type": "address"}, {"indexed": true, "name": "to", "type": "address"}, {"indexed": false, "name": "tokens", "type": "uint256"}],
                "name": "Transfer",
                "type": "event"
            }],
            playerbookAbi: [
                {"constant": false, "inputs": [], "name": "addMeToAllGames", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {
                    "constant": false,
                    "inputs": [{"name": "_whatFunction", "type": "bytes32"}],
                    "name": "deleteAnyProposal",
                    "outputs": [],
                    "payable": false,
                    "stateMutability": "nonpayable",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "", "type": "address"}],
                    "name": "pIDxAddr_",
                    "outputs": [{"name": "", "type": "uint256"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {"constant": true, "inputs": [], "name": "registrationFee_", "outputs": [{"name": "", "type": "uint256"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                    "constant": true,
                    "inputs": [],
                    "name": "getNameFee",
                    "outputs": [{"name": "", "type": "uint256"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "", "type": "uint256"}, {"name": "", "type": "bytes32"}],
                    "name": "plyrNames_",
                    "outputs": [{"name": "", "type": "bool"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "", "type": "address"}],
                    "name": "gameNames_",
                    "outputs": [{"name": "", "type": "bytes32"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "", "type": "bytes32"}],
                    "name": "pIDxName_",
                    "outputs": [{"name": "", "type": "uint256"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_nameString", "type": "string"}, {"name": "_affCode", "type": "address"}, {"name": "_all", "type": "bool"}],
                    "name": "registerNameXaddr",
                    "outputs": [],
                    "payable": true,
                    "stateMutability": "payable",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_gameAddress", "type": "address"}, {"name": "_gameNameStr", "type": "string"}],
                    "name": "addGame",
                    "outputs": [],
                    "payable": false,
                    "stateMutability": "nonpayable",
                    "type": "function"
                }, {"constant": true, "inputs": [], "name": "pID_", "outputs": [{"name": "", "type": "uint256"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                    "constant": true,
                    "inputs": [{"name": "_pID", "type": "uint256"}],
                    "name": "getPlayerAddr",
                    "outputs": [{"name": "", "type": "address"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_nameString", "type": "string"}, {"name": "_affCode", "type": "bytes32"}, {"name": "_all", "type": "bool"}],
                    "name": "registerNameXname",
                    "outputs": [],
                    "payable": true,
                    "stateMutability": "payable",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "_nameStr", "type": "string"}],
                    "name": "checkIfNameValid",
                    "outputs": [{"name": "", "type": "bool"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_addr", "type": "address"}, {"name": "_name", "type": "bytes32"}, {"name": "_affCode", "type": "bytes32"}, {"name": "_all", "type": "bool"}],
                    "name": "registerNameXnameFromDapp",
                    "outputs": [{"name": "", "type": "bool"}, {"name": "", "type": "uint256"}],
                    "payable": true,
                    "stateMutability": "payable",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "_whatFunction", "type": "bytes32"}, {"name": "_signerA", "type": "uint256"}, {"name": "_signerB", "type": "uint256"}, {"name": "_signerC", "type": "uint256"}],
                    "name": "checkSignersByAddress",
                    "outputs": [{"name": "", "type": "address"}, {"name": "", "type": "address"}, {"name": "", "type": "address"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_gameID", "type": "uint256"}],
                    "name": "addMeToGame",
                    "outputs": [],
                    "payable": false,
                    "stateMutability": "nonpayable",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "_pID", "type": "uint256"}],
                    "name": "getPlayerName",
                    "outputs": [{"name": "", "type": "bytes32"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_nameString", "type": "string"}, {"name": "_affCode", "type": "uint256"}, {"name": "_all", "type": "bool"}],
                    "name": "registerNameXID",
                    "outputs": [],
                    "payable": true,
                    "stateMutability": "payable",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "", "type": "uint256"}, {"name": "", "type": "uint256"}],
                    "name": "plyrNameList_",
                    "outputs": [{"name": "", "type": "bytes32"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "_whatFunction", "type": "bytes32"}],
                    "name": "checkData",
                    "outputs": [{"name": "", "type": "bytes32"}, {"name": "", "type": "uint256"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_addr", "type": "address"}, {"name": "_name", "type": "bytes32"}, {"name": "_affCode", "type": "address"}, {"name": "_all", "type": "bool"}],
                    "name": "registerNameXaddrFromDapp",
                    "outputs": [{"name": "", "type": "bool"}, {"name": "", "type": "uint256"}],
                    "payable": true,
                    "stateMutability": "payable",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_nameString", "type": "string"}],
                    "name": "useMyOldName",
                    "outputs": [],
                    "payable": false,
                    "stateMutability": "nonpayable",
                    "type": "function"
                }, {"constant": true, "inputs": [], "name": "gID_", "outputs": [{"name": "", "type": "uint256"}], "payable": false, "stateMutability": "view", "type": "function"}, {
                    "constant": false,
                    "inputs": [{"name": "_addr", "type": "address"}, {"name": "_name", "type": "bytes32"}, {"name": "_affCode", "type": "uint256"}, {"name": "_all", "type": "bool"}],
                    "name": "registerNameXIDFromDapp",
                    "outputs": [{"name": "", "type": "bool"}, {"name": "", "type": "uint256"}],
                    "payable": true,
                    "stateMutability": "payable",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_fee", "type": "uint256"}],
                    "name": "setRegistrationFee",
                    "outputs": [],
                    "payable": false,
                    "stateMutability": "nonpayable",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "", "type": "uint256"}],
                    "name": "games_",
                    "outputs": [{"name": "", "type": "address"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "", "type": "address"}],
                    "name": "gameIDs_",
                    "outputs": [{"name": "", "type": "uint256"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "", "type": "uint256"}],
                    "name": "plyr_",
                    "outputs": [{"name": "addr", "type": "address"}, {"name": "name", "type": "bytes32"}, {"name": "laff", "type": "uint256"}, {"name": "names", "type": "uint256"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "_pID", "type": "uint256"}],
                    "name": "getPlayerLAff",
                    "outputs": [{"name": "", "type": "uint256"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {
                    "constant": false,
                    "inputs": [{"name": "_addr", "type": "address"}],
                    "name": "getPlayerID",
                    "outputs": [{"name": "", "type": "uint256"}],
                    "payable": false,
                    "stateMutability": "nonpayable",
                    "type": "function"
                }, {
                    "constant": true,
                    "inputs": [{"name": "_whatFunction", "type": "bytes32"}, {"name": "_signerA", "type": "uint256"}, {"name": "_signerB", "type": "uint256"}, {"name": "_signerC", "type": "uint256"}],
                    "name": "checkSignersByName",
                    "outputs": [{"name": "", "type": "bytes32"}, {"name": "", "type": "bytes32"}, {"name": "", "type": "bytes32"}],
                    "payable": false,
                    "stateMutability": "view",
                    "type": "function"
                }, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"}, {
                    "anonymous": false,
                    "inputs": [{"indexed": true, "name": "playerID", "type": "uint256"}, {"indexed": true, "name": "playerAddress", "type": "address"}, {
                        "indexed": true,
                        "name": "playerName",
                        "type": "bytes32"
                    }, {"indexed": false, "name": "isNewPlayer", "type": "bool"}, {"indexed": false, "name": "affiliateID", "type": "uint256"}, {
                        "indexed": false,
                        "name": "affiliateAddress",
                        "type": "address"
                    }, {"indexed": false, "name": "affiliateName", "type": "bytes32"}, {"indexed": false, "name": "amountPaid", "type": "uint256"}, {
                        "indexed": false,
                        "name": "timeStamp",
                        "type": "uint256"
                    }],
                    "name": "onNewName",
                    "type": "event"
                }],
            web3: null,
            P3XTokenContract: null,
            P3XTokenAddress: '',
            P3XTokenContractEtherscan: '',
            P3DTokenContract: null,
            P3DTokenAddr: '',
            P3DTokenContractEtherscan: '',
            playerbookContract: null,
            playerbookContractAddr: '',
            playerbookContractEtherscan: '',
            txtResponse: {
                genericSendingTransErr: 'There was an error sending the transaction.',
                acquiredTimeGauntlet: {
                    dateIsValidErr: 'Date is not valid.',
                    balanceOfErr: 'You do not have enough P3X.',
                    amtErr: 'Stake amount cannot be 0 or less than 0.',
                    transSuccess: 'Your gauntlet order has been sent to the blockchain.'
                },
                acquiredSupplyGauntlet: {
                    supplyErr: 'End Supply cannot be 0 or less than 0.',
                    balanceOfErr: 'You do not have enough P3X.',
                    amtErr: 'Stake amount cannot be 0 or less than 0.',
                    transSuccess: 'Your gauntlet order has been sent to the blockchain.'
                },
                buy: {
                    amtNotValidErr: 'Please enter a valid number.',
                    amtNotZeroErr: 'Buy amount cannot be 0 or less than 0.',
                    transSuccess: 'Your buy order has been sent to the blockchain.'
                },
                sell: {
                    amtNotValidErr: 'Please enter a valid number.',
                    amtNotZeroErr: 'Sell amount cannot be 0 or less than 0.',
                    balanceOfErr: 'You do not have enough P3X.',
                    transSuccess: 'Your sell order has been sent to the blockchain.'
                },
                transfer: {
                    amtNotZero: 'Transfer amount cannot be 0 or less than 0.',
                    addressNotValid: 'Not a valid Ethereum address.',
                    transSuccess: 'Your transfer order has been sent to the blockchain.'
                },
                reinvestPartial: {
                    amtErr: 'Reinvest amount cannot be 0 or less than 0.',
                    totalDivsErr: 'Cannot reinvest more than your current divs holdings.',
                    transSuccess: 'Your partial reinvestment order has been sent to the blockchain.'
                },
                reinvest: {
                    transSuccess: 'Your reinvestment order has been sent to the blockchain.'
                },
                setReferrer: {
                    addressNotValid: 'Not a valid Ethereum address.',
                    transSuccess: 'Your order to set a new referrer has been sent to the blockchain.'
                },
                exit: {
                    transSuccess: 'Your exit order has been sent to the blockchain.'
                },
                withdraw: {
                    transSuccess: 'Your withdraw order has been sent to the blockchain.'
                }
            },

            //fetched data
            address: '',
            myGauntlets: {},
            savedReferral: '',
            sellPrice: '0',
            buyPrice: '0',
            totalEthereumBalance: '0',
            totalSupply: '0',
            usableBalanceOf: '0',
            balanceOf: '0',
            P3DBalanceOf: '0',
            refBonusOf: '0',
            totalDividendsOf: '0',
            P3XStakingRequirement: '0',
            P3DStakingRequirement: '0',
            totalGauntletEthAmt: '0',
            totalGauntletP3XAmt: '0',
            totalBalanceEthAmt: '0',

            //display
            totalEthereumBalance_Display: '0',
            totalSupply_Display: '0',
            usableBalanceOf_Display: '0',
            balanceOf_Display: '0',
            P3DBalanceOf_Display: '0',
            refBonusOf_Display: '0',
            totalDividendsOf_Display: '0',
            P3XStakingRequirement_Display: '0',
            P3DStakingRequirement_Display: '0',
            totalGauntletEthAmt_Display: '0',
            totalBalanceEthAmt_Display: '0'
        }
        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    }

    async componentWillMount() {
        await this.init();
    }

    async init() {
        // let parsedQs = queryString.parse(window.location.search);
        // if(window.location.protocal=='http:'){
        //     window.location.href = 'https://' + window.location.hostname + queryString.stringify(parsedQs);
        // }

        if (window.ethereum) {
            window.web3 = new Web3(window.ethereum);
            //console.log(window.web3);
            try {
                await window.ethereum.enable();
                this.setState({web3: window.web3});
                await this.getNetwork();
                await this.getData();
                await this.fiatPrices();
                await this.setFiatPrices();
                await this.setMasternode();
                await this.setStakingRequirement();
                await this.setGauntlets();
                await this.setState({status: false});
            } catch (error) {
                alert('You denied access to your metamask. You will not be able to utilize the site.');
            }
        }
        else if (window.web3) {
            window.web3 = new Web3(window.web3.currentProvider);
            this.setState({web3: window.web3});
            await this.getNetwork();
            await this.getData();
            await this.fiatPrices();
            await this.setFiatPrices();
            await this.setMasternode();
            await this.setStakingRequirement();
            await this.setGauntlets();
            await this.setState({status: false});
        }
        else {
            console.log('Non-Ethereum browser detected. You should consider trying MetaMask!');
        }
    }

    async getNetwork() {
        try {
            let network = await this.state.web3.eth.net.getId();
            switch (network) {
                case 1:
                    this.setState({
                        ethNetworkID: network,
                        ethNetwork: 'Mainnet',
                        etherscanAddr: 'https://etherscan.io',
                        P3XTokenAddress: '0x058a144951e062fc14f310057d2fd9ef0cf5095b',
                        P3DTokenAddr: '0xb3775fb83f7d12a36e0475abdd1fca35c091efbe',
                        playerbookContractAddr: '0xD60d353610D9a5Ca478769D371b53CEfAA7B6E4c',
                        P3XTokenContractEtherscan: 'https://etherscan.io/address/0x058a144951e062fc14f310057d2fd9ef0cf5095b',
                        P3DTokenContractEtherscan: 'https://etherscan.io/address/0xb3775fb83f7d12a36e0475abdd1fca35c091efbe',
                        playerbookContractEtherscan: 'https://etherscan.io/address/0xD60d353610D9a5Ca478769D371b53CEfAA7B6E4c'
                    });
                    break;
                case 3:
                    this.setState({
                        ethNetworkID: network,
                        ethNetwork: 'Ropsten',
                        etherscanAddr: 'https://ropsten.etherscan.io',
                        P3XTokenAddress: '0xcd45a142d109bbc8b22ff6028614027d1db4e32f',
                        P3DTokenAddr: '0x765a944008f08e8366c4ac4c88db63961f65be79',
                        playerbookContractAddr: '0x37ceaad5d949818cba87f155143290a8eb6ae501',
                        P3XTokenContractEtherscan: 'https://ropsten.etherscan.io/address/0xcd45a142d109bbc8b22ff6028614027d1db4e32f',
                        P3DTokenContractEtherscan: 'https://ropsten.etherscan.io/address/0x765a944008f08e8366c4ac4c88db63961f65be79',
                        playerbookContractEtherscan: 'https://ropsten.etherscan.io/address/0x37ceaad5d949818cba87f155143290a8eb6ae501'
                    });
                    break;
                default:

                    break;
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    async getData() {
        let sellPrice = '0', buyPrice = '0', totalEthereumBalance = '0', totalSupply = '0', savedReferral = '', usableBalanceOf = '0';
        let balanceOf = '0', totalDividendsOf = '0', refBonusOf = '0', myGauntlets = {}, P3DStakingRequirement = '0';
        let P3XStakingRequirement = '0', totalGauntletEthAmt = '0', totalBalanceEthAmt = '0', P3DBalanceOf = '0', P3XTokenContract = '';
        let P3DTokenContract = '', playerbookContract = '', userAddress = '';

        try {
            userAddress = await this.state.web3.eth.getAccounts();
            //console.log(userAddress[0]);
        }
        catch (error) {
            console.log(error);
        }
        try {
            P3XTokenContract = await new this.state.web3.eth.Contract(this.state.P3XAbi, this.state.P3XTokenAddress);
            //console.log(P3XTokenContract);
        }
        catch (error) {
            console.log(error);
        }
        try {
            P3DTokenContract = await new this.state.web3.eth.Contract(this.state.P3DAbi, this.state.P3DTokenAddr);
            //console.log(P3DTokenContract);
        }
        catch (error) {
            console.log(error);
        }
        try {
            playerbookContract = await new this.state.web3.eth.Contract(this.state.playerbookAbi, this.state.playerbookContractAddr);
            //console.log(playerbookContract);
        }
        catch (error) {
            console.log(error);
        }
        try {
            sellPrice = await P3DTokenContract.methods.sellPrice().call();
            //console.log(sellPrice);
        }
        catch (error) {
            console.log(error);
        }
        try {
            buyPrice = await P3DTokenContract.methods.buyPrice().call();
            //console.log(buyPrice);
        }
        catch (error) {
            console.log(error);
        }
        try {
            totalEthereumBalance = await P3DTokenContract.methods.totalEthereumBalance().call();
            //console.log(totalEthereumBalance);
        }
        catch (error) {
            console.log(error);
        }
        try {
            totalSupply = await P3DTokenContract.methods.totalSupply().call();
            //console.log(totalSupply);
        }
        catch (error) {
            console.log(error);
        }
        try {
            savedReferral = await P3XTokenContract.methods.savedReferral(userAddress[0]).call();
            //console.log(savedReferral);
        }
        catch (error) {
            console.log(error);
        }
        try {
            usableBalanceOf = await P3XTokenContract.methods.usableBalanceOf(userAddress[0]).call();
            //console.log(usableBalanceOf);
        }
        catch (error) {
            console.log(error);
        }
        try {
            balanceOf = await P3XTokenContract.methods.balanceOf(userAddress[0]).call();
            //console.log(balanceOf);
        }
        catch (error) {
            console.log(error);
        }
        try {
            P3DBalanceOf = await P3DTokenContract.methods.balanceOf(userAddress[0]).call();
            //console.log(P3DBalanceOf);
        }
        catch (error) {
            console.log(error);
        }
        try {
            totalDividendsOf = await P3XTokenContract.methods.dividendsOf(userAddress[0], true).call();
            //console.log(totalDividendsOf);
        }
        catch (error) {
            console.log(error);
        }
        try {
            refBonusOf = await P3XTokenContract.methods.refBonusOf(userAddress[0]).call();
            //console.log(refBonusOf);
        }
        catch (error) {
            console.log(error);
        }
        try {
            myGauntlets = await P3XTokenContract.methods.gauntletTypeOf(userAddress[0]).call();
            //console.log(myGauntlets);
        }
        catch (error) {
            console.log(error);
        }
        try {
            P3DStakingRequirement = await P3DTokenContract.methods.stakingRequirement().call();
            //console.log(P3DStakingRequirement);
        }
        catch (error) {
            console.log(error);
        }
        try {
            P3XStakingRequirement = await P3XTokenContract.methods.stakingRequirement().call();
            //console.log(P3XStakingRequirement);
        }
        catch (error) {
            console.log(error);
        }
        try {
            //console.log(myGauntlets[0]);
            if (myGauntlets[0] > 0) {
                totalGauntletEthAmt = await P3DTokenContract.methods.calculateEthereumReceived(myGauntlets[0]).call();
                //console.log('totalGauntletEthAmt: ' + totalGauntletEthAmt);
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            if(balanceOf>0) {
                totalBalanceEthAmt = await P3DTokenContract.methods.calculateEthereumReceived(balanceOf).call();
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            this.setState({
                P3XTokenContract: P3XTokenContract,
                P3DTokenContract: P3DTokenContract,
                playerbookContract: playerbookContract,
                address: userAddress[0],
                myGauntlets: myGauntlets,
                savedReferral: savedReferral,
                sellPrice: new BigNumber(this.state.web3.utils.fromWei(sellPrice, 'ether')).toFixed(8),
                buyPrice: new BigNumber(this.state.web3.utils.fromWei(buyPrice, 'ether')).toFixed(8),
                totalEthereumBalance: this.state.web3.utils.fromWei(totalEthereumBalance, 'ether'),
                totalSupply: this.state.web3.utils.fromWei(totalSupply, 'ether'),
                usableBalanceOf: new BigNumber(this.state.web3.utils.fromWei(usableBalanceOf, 'ether')).toFixed(4),
                balanceOf: this.state.web3.utils.fromWei(balanceOf, 'ether'),
                P3DBalanceOf: this.state.web3.utils.fromWei(P3DBalanceOf, 'ether'),
                refBonusOf: this.state.web3.utils.fromWei(refBonusOf, 'ether'),
                totalDividendsOf: this.state.web3.utils.fromWei(totalDividendsOf, 'ether'),
                P3XStakingRequirement: new BigNumber(this.state.web3.utils.fromWei(P3XStakingRequirement, 'ether')).toFixed(4),
                P3DStakingRequirement: new BigNumber(this.state.web3.utils.fromWei(P3DStakingRequirement, 'ether')).toFixed(4),
                totalGauntletEthAmt: this.state.web3.utils.fromWei(totalGauntletEthAmt, 'ether'),
                totalBalanceEthAmt: this.state.web3.utils.fromWei(totalBalanceEthAmt, 'ether'),

                //display
                totalEthereumBalance_Display: this.formatMoney(this.state.web3.utils.fromWei(totalEthereumBalance, 'ether'), 2),
                totalSupply_Display: this.formatMoney(this.state.web3.utils.fromWei(totalSupply, 'ether'), 2),
                usableBalanceOf_Display: this.formatMoney(this.state.web3.utils.fromWei(usableBalanceOf, 'ether'), 4),
                balanceOf_Display: this.formatMoney(this.state.web3.utils.fromWei(balanceOf, 'ether'), 4),
                P3DBalanceOf_Display: this.formatMoney(this.state.web3.utils.fromWei(P3DBalanceOf, 'ether'), 2),
                refBonusOf_Display: this.formatMoney(this.state.web3.utils.fromWei(refBonusOf, 'ether'), 4),
                totalDividendsOf_Display: this.formatMoney(this.state.web3.utils.fromWei(totalDividendsOf, 'ether'), 4),
                P3XStakingRequirement_Display: new BigNumber(this.state.web3.utils.fromWei(P3XStakingRequirement, 'ether')).toFixed(4),
                P3DStakingRequirement_Display: new BigNumber(this.state.web3.utils.fromWei(P3DStakingRequirement, 'ether')).toFixed(4),
                totalGauntletEthAmt_Display: this.formatMoney(this.state.web3.utils.fromWei(totalGauntletEthAmt, 'ether'), 4),
                totalBalanceEthAmt_Display: this.formatMoney(this.state.web3.utils.fromWei(totalBalanceEthAmt, 'ether'), 4)
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    formatMoney(n, c, d, t) {
        //adds commas to number
        c = isNaN(c = Math.abs(c)) ? 2 : c;
        d = d === undefined ? "." : d;
        t = t === undefined ? "," : t;
        var j, s = n < 0 ? "-" : "";
        var i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)));
        j = (j = i.length) > 3 ? j % 3 : 0;

        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }

    async fiatPrices() {
        //set currency from local Storage
        let ajax = await axios.get('https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=XMR,BTC,USD,EUR,CAD,JPY,GBP');
        this.setState({
            fiatPrices: ajax.data
        });
    }

    setFiatPrices() {
        let totalFiat = parseFloat(this.state.totalEthereumBalance) * parseFloat(this.state.fiatPrices[this.state.currency]);
        let fiatTotal = this.formatMoney(totalFiat, 2);

        let totalGauntlet = parseFloat(this.state.totalGauntletEthAmt) * parseFloat(this.state.fiatPrices[this.state.currency]);
        let fiatGauntlet = this.formatMoney(totalGauntlet, 2);

        let totalBal = parseFloat(this.state.totalBalanceEthAmt) * parseFloat(this.state.fiatPrices[this.state.currency]);
        let fiatBalance = this.formatMoney(totalBal, 2);

        let totalDivs = parseFloat(this.state.totalDividendsOf) * parseFloat(this.state.fiatPrices[this.state.currency]);
        let fiatDivs = this.formatMoney(totalDivs, 2);

        this.setState({
            fiatTotal: fiatTotal,
            fiatGauntlet: fiatGauntlet,
            fiatBalance: fiatBalance,
            fiatDivs: fiatDivs
        });
    }

    setStakingRequirement() {
        let str = BigNumber(this.state.P3XStakingRequirement).toFixed(2) + ' P3X or ' + BigNumber(this.state.P3DStakingRequirement).toFixed(2) + ' P3D';
        this.setState({stakingRequirementStr: str});
    }

    setMasternode() {
        //3 ways for MN
        //Default is mine.

        //then override if referrer is set
        if(this.state.web3.utils.isAddress(this.state.savedReferral) && this.state.savedReferral !='0x0000000000000000000000000000000000000000'){
            this.setState({
                MN:this.state.savedReferral
            });
            console.log('savedReferral: '+ this.state.MN);
        }

        //then override if querystring mn is set
        let mn = queryString.parse(window.location.search).mn;
        if (this.state.web3.utils.isAddress(mn)) {
            this.setState({
                MN:mn
            });
            console.log('querystring: '+this.state.MN);
        }

        console.log('Using Masternode: '+this.state.MN);
        if (parseFloat(this.state.balanceOf) >= parseFloat(this.state.P3XStakingRequirement) || parseFloat(this.state.P3DBalanceOf) >= parseFloat(this.state.P3DStakingRequirement)) {
            let path = window.location.protocol + '//' + window.location.hostname;
            let masterNode = path + '/p3x-exchange/?mn=' + this.state.address;
            this.setState({
                masterNodeLink: masterNode,
            });
        }
        else {
            this.setState({
                masterNodeLink: 'Purchase additional tokens to use a Masternode.',
            });
        }
    }



    async setGauntlets() {
        //console.log(this.state.minDate);
        try {
            let gauntletType = 0, gauntletEnd = 0, gauntletAmount = 0, myGauntlets = [], day = 0;
            myGauntlets = this.state.myGauntlets;
            gauntletType = new BigNumber(this.state.myGauntlets[1]);
            gauntletAmount = this.state.myGauntlets[0];

            switch (gauntletType.toString()) {
                case '1':
                    day = moment.unix(myGauntlets[2]).local().format('MM/DD/YYYY, h:mm A');
                    this.setState({
                        gauntletType: 'Time Based Gauntlet',
                        gauntletEndText: 'Gauntlet End Date:',
                        gauntletEndDateOrSupply: day,
                    });
                    break;
                case '2':
                    gauntletEnd = new BigNumber(myGauntlets[2]);
                    this.setState({
                        gauntletType: 'P3D Supply Based Gauntlet',
                        gauntletEndText: 'Gauntlet End Supply:',
                        gauntletEndDateOrSupply: this.formatMoney(gauntletEnd.div(1e18).toFixed(2)) + ' P3D',
                    });
                    break;
                default:
                    break;
            }
            if (gauntletAmount) {
                this.setState({
                    totalGauntletP3XAmt: this.formatMoney(this.state.web3.utils.fromWei(gauntletAmount), 2)
                });
            }
            let at = parseInt(this.state.totalSupply) + (parseInt(this.state.totalSupply) / 5) + 10;
            this.setState({
                gauntletMustStakeUntil: 'Minimum Staking Date: ' + moment().add(28, 'days').hours(24).minutes(0).seconds(0).local().format('MM/DD/YYYY, h:mm A'),
                gauntletMinimumSupply: BigNumber(at).toFixed(2),
                gauntletMinimumSupply_Display: this.formatMoney(BigNumber(at).toFixed(2), 2)
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    handleLanguageChange(event) {
        let val = event.target.getAttribute('data-language');
        alert(val);
    }

    async handleCurrencyChange(event) {
        let val = event.target.getAttribute('data-currency');
        //alert(val);
        await this.setState({
            currency: val
        });
        await this.setFiatPrices();
    }

    render() {
        let loading;
        if (this.state.status) {
            loading = <Loading/>;
        }

        return (
            <div className="container pt-3 pb-5 mb-5-">
                <Menu web3={this.state.web3} data={this.state} languageChange={this.handleLanguageChange} currencyChange={this.handleCurrencyChange}/>
                <BuySell web3={this.state.web3} data={this.state}/>
                <Reinvest web3={this.state.web3} data={this.state}/>
                <Staking web3={this.state.web3} data={this.state}/>
                <MasterNode web3={this.state.web3} data={this.state}/>
                <Transfer web3={this.state.web3} data={this.state}/>
                {loading}
                <Footer web3={this.state.web3} data={this.state}/>
            </div>
        );
    }
}



export default App;
